"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _q = _interopRequireDefault(require("q"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _getIsAdmin = require("ui-addon-upgrades/_core/common/eligibility/getIsAdmin");

var _getSeatedProductOwned = require("../eligibility/getSeatedProductOwned");

var _products = require("../data/upgradeData/properties/products");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _AdminModal = _interopRequireDefault(require("./AdminModal"));

var _AdminModalTypes = _interopRequireDefault(require("../constants/AdminModalTypes"));

var _Trials = require("self-service-api/constants/Trials");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _getProductNameText = require("../adapters/getProductNameText");

var _links = require("../navigation/links");

var RequestSeatBannerWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RequestSeatBannerWrapper, _Component);

  function RequestSeatBannerWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RequestSeatBannerWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RequestSeatBannerWrapper).call(this, props));
    _this.state = {
      isTeamAdmin: 'initial',
      seatedProductOwned: 'initial',
      isSeatBasedProduct: true,
      isRequestSeatModalOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(RequestSeatBannerWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props$upgradeDa = this.props.upgradeData,
          upgradeProduct = _this$props$upgradeDa.upgradeProduct,
          product = _this$props$upgradeDa.product;

      if (product === _products.productTypes.SALES || product === _products.productTypes.SERVICE) {
        var getIsAdminPromise = (0, _getIsAdmin.getIsAdmin)(_AdminTypes.TEAM);
        var getSeatedProductOwnedPromise = (0, _getSeatedProductOwned.getSeatedProductOwned)({
          upgradeProduct: upgradeProduct,
          product: product
        });

        _q.default.Promise.all([getIsAdminPromise, getSeatedProductOwnedPromise]).then(function (_ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
              isTeamAdmin = _ref2[0],
              seatedProductOwned = _ref2[1];

          _this2.setState({
            isTeamAdmin: isTeamAdmin,
            seatedProductOwned: seatedProductOwned
          });
        });
      } else {
        this.setState({
          isSeatBasedProduct: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          upgradeProduct = _this$props.upgradeData.upgradeProduct,
          upgradeData = _this$props.upgradeData;
      var _this$state = this.state,
          isTeamAdmin = _this$state.isTeamAdmin,
          seatedProductOwned = _this$state.seatedProductOwned,
          isSeatBasedProduct = _this$state.isSeatBasedProduct,
          isRequestSeatModalOpen = _this$state.isRequestSeatModalOpen;

      if (!isSeatBasedProduct || seatedProductOwned === 'initial' || isTeamAdmin === 'initial') {
        return children;
      }

      var productName = (0, _getProductNameText.getProductNameText)(upgradeProduct);

      if (seatedProductOwned) {
        if (isTeamAdmin) {
          tracker.track('requestSeatBannerInteraction', (0, _extends2.default)({
            banner: 'assign yourself a seat',
            action: 'viewed'
          }, upgradeData));
          return _react.default.createElement("div", {
            className: "private-upgrades-message"
          }, _react.default.createElement("p", {
            className: "m-bottom-0 private-upgrades-message-text m-right-4"
          }, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.requestSeatBanner.assignYourselfASeat.text",
            options: {
              productName: productName
            }
          })), _react.default.createElement(_UIButton.default, {
            className: "private-upgrades-message-button",
            size: "small",
            use: "primary-white",
            external: true,
            href: (0, _links.paidUserManagementLink)(),
            onClick: function onClick() {
              tracker.track('requestSeatBannerInteraction', (0, _extends2.default)({
                banner: 'assign yourself a seat',
                action: 'clicked users and teams link'
              }, upgradeData));
            }
          }, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.requestSeatBanner.assignYourselfASeat.button"
          })));
        } else {
          tracker.track('requestSeatBannerInteraction', (0, _extends2.default)({
            banner: 'request seat from admin',
            action: 'viewed'
          }, upgradeData));
          return _react.default.createElement("div", {
            className: "private-upgrades-message"
          }, _react.default.createElement("p", {
            className: "m-bottom-0 private-upgrades-message-text m-right-4"
          }, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.requestSeatBanner.requestSeatFromAdmin.text",
            options: {
              productName: productName
            }
          })), _react.default.createElement(_UIButton.default, {
            className: "private-upgrades-message-button",
            size: "small",
            use: "primary-white",
            onClick: function onClick() {
              _this3.setState({
                isRequestSeatModalOpen: true
              });

              tracker.track('requestSeatBannerInteraction', (0, _extends2.default)({
                banner: 'request seat from admin',
                action: 'clicked request seat button'
              }, upgradeData));
            }
          }, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.requestSeatBanner.requestSeatFromAdmin.button"
          })), isRequestSeatModalOpen && _react.default.createElement(_AdminModal.default, {
            merchandiseId: _Trials.upgradeProductToMerchIds[upgradeProduct],
            modalType: _AdminModalTypes.default.REQUEST_SEAT_UPGRADE_BANNER,
            onReject: function onReject() {
              return _this3.setState({
                isRequestSeatModalOpen: false
              });
            },
            onConfirm: function onConfirm() {
              return _this3.setState({
                isRequestSeatModalOpen: false
              });
            }
          }));
        }
      } else {
        return children;
      }
    }
  }]);
  return RequestSeatBannerWrapper;
}(_react.Component);

RequestSeatBannerWrapper.propTypes = {
  children: _react.PropTypes.node.isRequired,
  upgradeData: _react.PropTypes.object.isRequired
};
var _default = RequestSeatBannerWrapper;
exports.default = _default;
module.exports = exports.default;